import log from 'loglevel';
import PropTypes from 'prop-types';
import React from 'react';

// Set level once at module load
log.setLevel(process.env.LOG_LEVEL || 'debug');

/**
 * Returns the shared loglevel instance. Use this instead of importing log directly
 * so logging is consistent and level is configured in one place.
 */
export function useLogger() {
  return log;
}

/**
 * @deprecated Prefer useLogger() hook.
 */
export const withLogger = (WrappedComponent) => {
  return function LoggerComponent(props) {
    return <WrappedComponent {...props} logger={log} />;
  };
};

export const LoggerProps = PropTypes.shape({
  debug: PropTypes.func,
  error: PropTypes.func,
  info: PropTypes.func,
  warn: PropTypes.func,
});
